const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
export function executiveFinanceModel(finance, currency, year) {
  const valid = finance?.success && finance?.dashboard && finance.by_currency?.[currency];
  const stats = valid ? finance.by_currency[currency] : null;
  const summary = valid ? finance.dashboard.by_currency?.[currency] : null;
  const series = new Map((summary?.monthly || []).map(row => [row.month, row]));
  const categories = summary?.categories || [];
  const displayed = categories.slice(0, 6);
  if (categories.length > 6) displayed.push({ name: 'Otras categorías', value: categories.slice(6).reduce((sum, row) => sum + row.value, 0) });
  return {
    financeAvailable: Boolean(valid), invoiced: stats?.invoicesAmount ?? null, paid: stats?.totalRevenue ?? null,
    receivable: stats?.pendingAmount ?? null, directExpenses: stats?.totalExpenses ?? null,
    invoiceCount: summary?.invoice_count || 0, documentCount: summary?.document_count || 0,
    collectionRate: stats?.invoicesAmount > 0 ? Math.min(100, Math.round((summary?.gross_collected || 0) / stats.invoicesAmount * 100)) : 0,
    recent: summary?.recent || [], categories: displayed,
    monthly: months.map((name, index) => { const row = series.get(`${year}-${String(index + 1).padStart(2, '0')}`); return { name, ingresos: row?.invoiced || 0, cobrado: row?.revenue || 0, gastos: row?.expenses || 0 }; })
  };
}
